import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { SubscriptionPlanListData } from "../actions";
import { SubscriptionPlanListApi } from "../api";
import { SUBSCRIPTION_PLAN_LIST } from "../constants";
 
function* SubscriptionPlanListService() {
  try {
    // yield put(FetchStart());
    const res = yield call(SubscriptionPlanListApi);
    if (res) {
      console.log(res.data);
      yield put(SubscriptionPlanListData(res.data));
    } else {
    }
    // yield put(FetchSuccess());
  } catch (error) {}
}

 
 
export function* SubscriptionPlanSaga() {
  yield takeEvery(SUBSCRIPTION_PLAN_LIST, SubscriptionPlanListService);
}
 
 

export default function* rootSaga() {
  yield all([fork(SubscriptionPlanSaga) ]);
}
